import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { ModalFormProps } from './types';
import { ModalFormContent } from './ModalFormContent';

const forwardedModalForm = React.forwardRef(
  <TFields,>(
    props: ModalFormProps<TFields>,
    ref: React.ForwardedRef<HTMLFormElement>,
  ): ReactElement => {
    const {
      // modal props
      open,
      setOpen,
      title,
      subtitle,
      size,
      titleAlignment,
      textAlignment,
      afterLeave,
      overlayCloseDisabled,
      variant,
      withoutBackdrop,

      ...modalFormContentProps
    } = props;

    const modalProps = {
      open,
      setOpen,
      title,
      subtitle,
      size,
      titleAlignment,
      textAlignment,
      afterLeave,
      overlayCloseDisabled,
      variant,
      withoutBackdrop,
    };

    return (
      <Modal {...modalProps} actionsPanel={null}>
        <ModalFormContent
          {...modalFormContentProps}
          setOpen={setOpen}
          ref={ref}
        />
      </Modal>
    );
  },
);

type ForwardedModalForm = <TFields>(
  props: ModalFormProps<TFields> & {
    ref?: React.ForwardedRef<HTMLFormElement>;
  },
) => ReturnType<typeof forwardedModalForm>;

export const ModalForm = forwardedModalForm as ForwardedModalForm;
